import React from 'react';
import {ReviewUnit} from "@onegovbugs/onegov-react-components";
import styles from "./ReviewUnitApplication.module.scss";

export const ImportExportDetailsReviewUnit = ({importExportDetails}) => {   
    return (
        <ReviewUnit
            title={"Introduction"}
            // onEdit={() => props.history.push("/import-export")}
        >
            <div className={`row ${styles.infoLine}`}>
            <div className={"col-12 col-md-6"}>
                <div>
                <em>Are you applying for an Import or Export Licence?</em>
                </div>
                <div className={styles.camelCase}>{importExportDetails.ieType}</div>
            </div>
            <div className={"col-12 col-md-6"}>
                <div>
                <em>Are you an Individual Applicant or applying on behalf of a Business?</em>
                </div>
                <div className={styles.camelCase}>{importExportDetails.appType}</div>
            </div>         
            </div>
        </ReviewUnit>
      
    )
}